export default {

	watchId: null,

	startWatching(callBack) {
		if(this.watchId !== null) return;

		this.watchId = navigator.geolocation.watchPosition(callBack, ()=>{}, {
			enableHighAccuracy: true
		});
	},

	stopWatching(callBack) {
		navigator.geolocation.clearWatch(this.watchId);
	},
};
